module.exports = __webpack_public_path__ + "img/icone-shopping-Cart.df741bce.png";